const numberFormatCompact = Intl.NumberFormat("en-US", {
  notation: "compact",
  maximumFractionDigits: 1,
});

export function formatCompactNumber(value: number) {
  return numberFormatCompact.format(value);
}

const numberFormatterStandard = Intl.NumberFormat("en-US", {
  notation: "standard",
});

export function formatStandardNumber(value: number) {
  return numberFormatterStandard.format(value);
}

const currencyUSD = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export function formatToUSD(value: number) {
  return currencyUSD.format(value);
}

export function formatToUSDWithCurrency(value: number) {
  return formatToUSD(value) + " USD";
}

export function formatCentsToUSDWithCurrency(cents: number) {
  const dollars = cents / 100;
  return formatToUSD(dollars) + " USD";
}

export function formatToUSDFromCents(cents: number) {
  const dollars = cents / 100;
  return currencyUSD.format(dollars);
}
